import { Zap } from 'lucide-react';
import StreakTracker from '../sections/StreakTracker';
import { DialogTrigger, DialogContent, DialogTitle } from '../ui/dialog';

const WeeklyStreakPopup = ({
    streakData = [],
    currentStreak = 0,
    open,
    onOpenChange,
    isMobile,
    isActive = false,
}) => {
    const zapColor = isActive ? 'text-gold' : 'text-neutral-500';

    if (isMobile) {
        return (
            <button
                type="button"
                aria-label="View streak"
                className="relative rounded-md hover:bg-neutral-200 ease-in-out duration-200"
                onClick={() => onOpenChange(!open)}
            >
                <Zap className={`${zapColor}`} fill="currentColor" />
            </button>
        );
    }

    return (
        <>
            <DialogTrigger className="relative rounded-md text-neutral-700 hover:bg-neutral-200 ease-in-out duration-200">
                <Zap className={`${zapColor}`} fill="currentColor" />
            </DialogTrigger>
            <DialogContent
                showCloseButton={false}
                className="fixed top-16 left-2 right-2 sm:left-auto sm:right-10 h-auto w-auto max-w-[calc(100vw-1rem)] sm:max-w-lg sm:w-96 mx-auto border border-neutral-300 bg-background duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right translate-x-0 translate-y-0 rounded-lg z-50"
            >
                <DialogTitle className="sr-only text-lg">Weekly Streak</DialogTitle>
                <StreakTracker streakData={streakData} currentStreak={currentStreak} />
            </DialogContent>
        </>
    );
};

export default WeeklyStreakPopup;
